import React from 'react'
import styles from './AppleSignInButton.module.css'
import AppleIcon from '../../assets/apple/logo-apple.webp'

type Props = {
  onSuccess: (response: any) => void
  onError?: (error: any) => void
  label?: string
  token?: string
  mode?: 'login' | 'registration'
}

export function AppleSignInButton({
  onSuccess,
  onError,
  label = 'Iniciar sesión con Apple',
  token,
  mode = 'login',
}: Props) {
  const handleClick = () => {
    const clientId = 'com.aicrumit.careme.web.login'

    const backendUrl = 'https://backend.caremeathome.com'

    const redirectUri = encodeURIComponent(`${backendUrl}/users/apple/callback`)
    const scope = encodeURIComponent('name email')

    const state = mode === 'registration' && token ? `registration:${token}` : 'login'

    const authUrl = `https://appleid.apple.com/auth/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${encodeURIComponent(
      state
    )}&response_mode=form_post`

    const width = 500
    const height = 600
    const left = (window.screen.width - width) / 2
    const top = (window.screen.height - height) / 2

    const messageListener = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return

      if (event.data.type === 'APPLE_OAUTH_SUCCESS') {
        onSuccess({
          ...event.data.user,
          operation: event.data.operation,
          message: event.data.message,
          isExistingUser: event.data.isExistingUser || false,
          registrationComplete:
            event.data.operation === 'registration' ||
            event.data.operation === 'existing_user_login',
        })
        window.removeEventListener('message', messageListener)
      } else if (event.data.type === 'APPLE_OAUTH_ERROR') {
        const errorDetails = {
          message: event.data.error || 'Error en la autenticación con Apple',
          code: event.data.errorCode || 'UNKNOWN_ERROR',
          originalError: event.data.originalError,
        }

        if (onError) {
          onError(errorDetails)
        }
        window.removeEventListener('message', messageListener)
      }
    }

    window.addEventListener('message', messageListener)

    const popup = window.open(
      authUrl,
      'AppleOAuth',
      `width=${width},height=${height},top=${top},left=${left}`
    )

    if (!popup) {
      if (onError) {
        onError({
          message: 'No se pudo abrir la ventana de autenticación',
          code: 'POPUP_BLOCKED',
        })
      }
      window.removeEventListener('message', messageListener)
      return
    }

    const checkClosed = setInterval(() => {
      if (popup?.closed) {
        window.removeEventListener('message', messageListener)
        clearInterval(checkClosed)
      }
    }, 500)
  }

  return (
    <button className={styles.appleButton} onClick={handleClick} type="button">
      <div className={styles.iconContainer}>
        <img src={AppleIcon} alt="Apple" className={styles.appleIcon} />
      </div>
      <span className={styles.buttonText}>{label}</span>
    </button>
  )
}
